import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryOptions from './baseQueryOptions';

export const baseApi = createApi({
  reducerPath: 'baseApi',
  baseQuery: baseQueryOptions,
  tagTypes: [
    'Alert',
    'Case',
    'Cases',
    'CasesStatistics',
    'CompanySearch',
    'Contact',
    'DetailCompanyInfo',
    'Dispute',
    'DraftCase',
    'KycStatus',
    'LastSuccess',
    'Logs',
    'MassDelegation',
    'MasterFinancialInfo',
    'MasterInfo',
    'Mapping',
    'Movement',
    'PlannedReminders',
    'Portfolio',
    'Reminders',
    'Subscriptions',
    'Tenant',
    'Tiers',
    'TierListCounters',
    'Tracking',
    'User',
    'UserInfo',
  ],
  endpoints: () => ({}),
});
